export default "__VITE_ASSET__779bc8c4__"